export class CohabitantModelFull {
  document: {
    number: string;
  };

  constructor() {
    this.document = {
      number: '',
    };
  }
}
